import React, { useState, useEffect, useCallback } from 'react';
import MuiAlert, { AlertProps, type Color } from '@material-ui/lab/Alert';
import {
  Button as ButtonM,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  TextField,
  Typography,
  withStyles
} from '@material-ui/core';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../../../services/api';
import { Autocomplete } from '@material-ui/lab';
import {
  capitalFirstLetter,
  maskCPF,
  getFileName,
  sendFileWithoutFake,
  verifyUpLoads
} from '../../../../utils/masks';
import { Guia } from '../../PDF/gerarGuia';
import { PDF } from '../../PDF/gerarPdf';
import { GetApp, Publish } from '@material-ui/icons';
import { type AxiosResponse } from 'axios';
import { ASO } from '@data/tipoAso';
import { status } from '@data/status';
import { KitProps } from '@dtos/kitDTO';
import { AppError } from '@utils/AppError';
import { FichaClinica } from '@pages/Agendamentos/PDF/fichaClinica';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getDataScheduling } from '@api/get-data-schedule';
import { LoadingPage } from '@components/LoadingPage';
import { Button } from '@components/Button';
import { postDownloadFicha } from '@api/post-download-ficha';
import { LabelUpload } from './input';
import { Check, Upload } from '@phosphor-icons/react';
import { LinkKitButton } from '@components/LinkKitButton';

interface INomeComercial {
  id_clinicas_credenciadas: number;
  contrato: string;
  nome_comercial: string;
  razao_social: string;
  cpf_cnpj: string;
  dias_funcionamento: string;
  cep: string;
  rua: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  nome_med: string;
  crm: string;
  crm_estado: string;
  trabalho_agendamento: string;
  pagamento_adiantado: string;
  telemedicina: string;
  observacao: string;
}

interface TFile {
  nome_aso: string;
  nome_prontuario: string;
}

const ButtonAdd = withStyles(() => ({
  root: {
    background: '#0D9C5B',
    color: '#FFF',
    border: 'none',
    '&:hover': {
      background: '#FFF',
      borderColor: '#0D9C5B',
      color: '#0D9C5B',
      border: 'solid 1px #0D9C5B'
    }
  }
}))(ButtonM);
const ButtonSair = withStyles(() => ({
  root: {
    background: 'red',
    color: '#FFF',
    border: 'none',
    '&:hover': {
      background: '#FFF',
      borderColor: 'red',
      color: 'red',
      border: 'solid 1px red'
    }
  }
}))(ButtonM);

export const EditNotisTelemedicina: React.FC<any> = (props) => {
  // console.log(props)
  const { id } = useParams<{ id: string }>();
  const { id_agendamento } = props.location.state;

  const [listCredenciado, setListCredenciado] = useState<INomeComercial[]>([]);
  const [selectedNomeComercial, setSelectedNomeComercial] = useState<any>();
  const [searchEmail, setSearchEmail] = useState<any>();
  const [emailAgendamento, setEmailAgendamento] = useState([]);

  const [arquivoSendASO, setArquivoSendASO] = useState<File | string>('');
  const [arquivoProntuario, setArquivoProntuario] = useState<File | string>('');

  const [viewFileASO, setViewFileASO] = useState<object | string | null>('');
  const [arquivoASO, setArquivoASO] = useState<File | string>('');

  const [arquivoSendProntuario, setArquivoSendProntuario] = useState<
    File | string
  >('');
  const [viewFileProntuario, setViewFileProntuario] = useState<
    object | string | null
  >('');

  const [statusAgendamento, setStatusAgendameto] = useState<string>('');
  const [cpfColab, setCpfColab] = useState<string>('');
  const [nomeColab, setNomeColab] = useState<string>('');
  const [estado, setEstado] = useState<string>('');
  const [cidade, setCidade] = useState<string>('');
  const [dataAgendamento, setDataAgendamento] = useState('');
  const [horarioAgendamento, setHorarioAgendamento] = useState<string>('');
  const [tipoAso, setTipoAso] = useState<string>('');
  const [obs, setObs] = useState<string>('');
  const [nomeComercial, setNomeComercial] = useState<string>('');
  const nome_user = localStorage.getItem('NameUser') || '';
  const [cnpjComercial, setCnpjComercial] = useState('');

  const PRESENCIAL_PAGE = 'presencial';

  const [snack, setSnack] = useState<boolean>(false);
  const [message, setMessage] = useState('');
  const [cod, setCod] = useState('');
  const [severity, setSeverity] = useState<Color>();
  const [ordemChegada, setOrdemChegada] = useState<string>('');
  const [isLoandingComercialName, setIsLoandingComercialName] = useState(false);

  async function sendAgendamento() {
    const hora = new Date();

    const newHora = hora.toLocaleString('pt-BR', { hour12: false });
    const data = {
      status: statusAgendamento,
      observacao: obs,
      tipo_aso: tipoAso,
      horario: horarioAgendamento,
      data_agendamento: dataAgendamento,
      estado: estado,
      cidade: cidade,
      nome_comercial:
        selectedNomeComercial?.nome_comercial ||
        getDataSchedule?.nome_comercial,
      tipo_agendamento: getDataSchedule?.tipo_agendamento,
      nome: nomeColab,
      cpf_colaborador: cpfColab,
      cpf_cnpj_comer:
        selectedNomeComercial?.cpf_cnpj || getDataSchedule?.cpf_cnpj_comer,
      usuario: `${nome_user} ${newHora}`,
      ordem_chegada: ordemChegada,
      email_agendamento: emailAgendamento,
      arquivo_aso: arquivoASO || getDataSchedule?.arquivo_aso,
      arquivo_prontuario:
        arquivoProntuario || getDataSchedule?.arquivo_prontuario,
      num_agenda: getDataSchedule?.num_agenda,
      linkDoatendimento: ''
    };
    // console.log(data);
    await api
      .post(`/ravim/atualizar-agendamento`, data)
      .then((res) => {
        if (res.status === 200) {
          setCod(String(res.status));
          setSnack(true);
          setSeverity('success');
          setMessage(res.data.message);
          setTimeout(() => {
            window.location.replace('/agendamentos');
          }, 2000);
        } else {
          setCod(String(res.status));
          setSnack(true);
          setSeverity('error');
          setMessage(res.data.message);
        }
      })
      .catch((err) => {
        setCod(err.code);
        setSnack(true);
        setSeverity('error');
        setMessage(err.message);
      });

    const formData = new FormData();
    formData.append('arquivo1', arquivoSendProntuario);
    formData.append('arquivo2', arquivoSendASO);

    await api
      .post(`/file`, formData)
      .then((res: AxiosResponse) => {})
      .catch((err) => {
        console.log(err);
      });
  }

  const {
    data: getDataSchedule,
    error: errorDataSchedule,
    isFetching
  } = useQuery({
    queryKey: ['getSchedule'],
    queryFn: () => getDataScheduling(id_agendamento)
  });

  async function reqStatus() {
    const data = {
      tipo_agendamento: getDataSchedule?.tipo_agendamento,
      tipo: getDataSchedule?.tipo_agendamento
    };
    setIsLoandingComercialName(true);
    try {
      const response = await api.post(`/ravim/telemed-clinicas`, data);

      if (response.status === 200) {
        setListCredenciado(response.data);
        response.data.map((a: INomeComercial) => {
          if (a.nome_comercial === getDataSchedule?.nome_comercial) {
            setCnpjComercial(a.cpf_cnpj);
            setSearchEmail(a.cpf_cnpj);
            setEstado(a.cidade);
            setCidade(a.estado);
          }
        });
        return;
      }
    } catch (err) {
      if (err instanceof AppError) {
        console.log(err.message);
      }
    } finally {
      setIsLoandingComercialName(false);
    }
  }

  const { mutateAsync: fetchFichaClinica } = useMutation({
    mutationFn: postDownloadFicha,
    onSuccess(data) {
      //console.log(data.data);
      FichaClinica(data.data);
    },
    onError(error) {
      if (error instanceof AppError) {
        setCod(String(error.code));
        setSnack(true);
        setSeverity('error');
        setMessage(error.message);
      }
    }
  });

  /* const fetchFichaClinica = useCallback(
    async (cpf_colaborador: string, cpf_cnpj: string) => {
      const data = {
        cpf_colaborador,
        cnpj_cpf_comer: cpf_cnpj
      };

      try {
        const res = await api.post(`/ravim/colab-kit-salvo`, data);

        FichaClinica(res.data);
      } catch (error) {
        if (error instanceof AppError) {
          setCod(String(error.code));
          setSnack(true);
          setSeverity('error');
          setMessage(error.message);
        }
      }
    },
    []
  ); */

const reqpdf = useCallback(
  async (
    tipo: number,
    cpf_colaborador: string,
    cpf_cnpj_comer: string,
    num_agenda: string,
    cnpj_empresa: string
  ) => {
    try {
      const payload = {
        cpf_colaborador,
        cnpj_cpf_comer: cpf_cnpj_comer,
        num_agenda,
        cnpj_empresa, // Garantindo que está no payload
      };
      
      // console.log("Payload enviado para /ravim/pdf:", payload); // Debug

      const res = await api.post(`/ravim/pdf`, payload);

      if (tipo === 1) {
        Guia(res.data, PRESENCIAL_PAGE);
      } else {
        PDF(res.data, '');
      }
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      if (error instanceof AppError) {
        setCod(String(error.code));
        setSnack(true);
        setSeverity('error');
        setMessage(error.message);
      }
    }
  },
  []
);
  async function downloadFile(arquivo: string) {
    const data = {
      arquivo
    };

    api
      .post(`/ravim/download`, data)
      .then((res) => {
        const url = res.data.dados;
        const link = document.createElement('a');
        link.href = url;
        link.download = arquivo.replace(/[_]/g, ' ');
        link.dispatchEvent(new MouseEvent('click'));
      })
      .catch((err) => {
        if (err instanceof AppError) {
          console.log(err);
        }
      });
  }

  const changeFileASO = (event: any) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      setArquivoASO(sendFileWithoutFake(event.target.value));
      setArquivoSendASO(event.target.files[0]);
      // console.log(event.target.files[0])
      setViewFileASO(URL.createObjectURL(event.target.files[0]));
    } else {
      console.log('cancelado');
    }
  };

  const changeFileProntuario = (event: any) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      setArquivoProntuario(sendFileWithoutFake(event.target.value));
      setArquivoSendProntuario(event.target.files[0]);

      // console.log(event.target.files[0])

      setViewFileProntuario(URL.createObjectURL(event.target.files[0]));
    } else {
      console.log('cancelado');
    }
  };

  useEffect(() => {
    setStatusAgendameto(getDataSchedule?.status ?? '');
    setCpfColab(getDataSchedule?.cpf_colaborador ?? '');
    setNomeColab(getDataSchedule?.nome ?? '');
    setNomeComercial(getDataSchedule?.nome_comercial ?? '');
    setDataAgendamento(getDataSchedule?.data_agendamento ?? '');
    setHorarioAgendamento(getDataSchedule?.horario ?? '');
    setOrdemChegada(getDataSchedule?.ordem_chegada ?? '');
    setTipoAso(getDataSchedule?.tipo_aso ?? '');
    setObs(getDataSchedule?.observacao ?? '');
  }, [isFetching]);

  useEffect(() => {
    setNomeComercial(selectedNomeComercial?.nome_comercial);
  }, [selectedNomeComercial]);

  function handleData(event: INomeComercial) {
    setSearchEmail(event.cpf_cnpj);
    setSelectedNomeComercial(event);
    setCnpjComercial(event.cpf_cnpj);
    setEstado(event.cidade);
    setCidade(event.estado);
  }

  if (!getDataSchedule) return;

  return (
    <Container>
      <LoadingPage open={isFetching} onClick={() => {}} />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: 20,
          gap: 20
        }}
      >
        {verifyUpLoads(getDataSchedule?.arquivo_aso) !== '' ? (
          <Button
            title="Download ASO"
            icon={<GetApp />}
            onClick={async () => {
              await downloadFile(
                getFileName(String(getDataSchedule?.arquivo_aso))
              );
            }}
          />
        ) : (
          <></>
        )}
        {verifyUpLoads(getDataSchedule?.arquivo_prontuario) !== '' ? (
          <Button
            title="Download Prontuário"
            icon={<GetApp />}
            onClick={async () => {
              await downloadFile(
                getFileName(String(getDataSchedule?.arquivo_prontuario))
              );
            }}
          />
        ) : (
          <></>
        )}

        <Button
          icon={<GetApp style={{ fontSize: 20 }} />}
          onClick={() => {
            fetchFichaClinica({
              cpf_colaborador: getDataSchedule.cpf_colaborador,
              cnpj_cpf_comer: getDataSchedule.cpf_cnpj_comer,
              num_agenda: getDataSchedule.num_agenda // BUG FIX: garante a ficha do agendamento correto
            });
          }}
          title="Download KIT - Ficha clínica"
          variantstyle="PURPLE"
        />

        <Button
          title="Download KIT - ASO"
          icon={<GetApp style={{ fontSize: 20 }} />}
          variantstyle="PURPLE"
          onClick={() =>
            reqpdf(
              2,
              getDataSchedule?.cpf_colaborador,
              getDataSchedule?.cpf_cnpj_comer,
              getDataSchedule?.num_agenda,
              getDataSchedule?.cnpj_empresa
            )
          }
        />

        <Button
          title="Download Guia"
          icon={<GetApp style={{ fontSize: 20 }} />}
          variantstyle="DARK_PINK"
          onClick={() => {
            reqpdf(
              1,
              getDataSchedule?.cpf_colaborador,
              getDataSchedule?.cpf_cnpj_comer,
              getDataSchedule?.num_agenda,
              getDataSchedule?.cnpj_empresa
            );
          }}
        />
      </div>
      <Typography
        variant="h4"
        align="center"
        style={{ marginBottom: 20, fontWeight: 'bold' }}
      >
        Editar Agendamento Presencial
      </Typography>
      <Paper style={{ padding: 40 }}>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Updates
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              {/* <input
                id="arquivoASO"
                name="fileASO"
                type="file"
                onChange={changeFileASO}
                style={{ display: 'none' }}
              />
              <label htmlFor="arquivoASO">
                <Button title="Upload - ASO" variantstyle="DARK_PINK" />
                <Typography>{String(arquivoASO)}</Typography>
              </label> */}
              <LabelUpload
                icon={
                  String(arquivoASO) ? (
                    <Check size={24} />
                  ) : (
                    <Upload size={24} />
                  )
                }
                title="Upload - ASO"
                variantstyle="DARK_PINK"
                htmlFor="arquivoASO"
                onChange={changeFileASO}
              />

              {/* <input
                id="arquivoProntuario"
                name="fileProntuario"
                type="file"
                onChange={changeFileProntuario}
                style={{ display: 'none' }}
              />
              <label htmlFor="arquivoProntuario">
                <Button title="Upload-Prontuário" variantstyle="LIGHT_PINK" />
                <Typography>{String(arquivoProntuario)}</Typography>
              </label> */}
              <LabelUpload
                title="Upload-Prontuário"
                variantstyle="LIGHT_PINK"
                htmlFor="arquivoProntuario"
                icon={
                  String(arquivoProntuario) ? (
                    <Check size={24} />
                  ) : (
                    <Upload size={24} />
                  )
                }
                onChange={changeFileProntuario}
              />
            </div>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Status
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <FormControl variant="outlined" style={{ width: '20%' }}>
                <InputLabel>Status</InputLabel>
                <Select
                  label="Status"
                  value={statusAgendamento}
                  onChange={(e: any) => {
                    setStatusAgendameto(e.target.value);
                  }}
                >
                  {status.map((status, index) => (
                    <MenuItem key={index} value={status.value}>
                      {status.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Colaborador
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <TextField
                label="CPF"
                disabled
                variant="outlined"
                fullWidth
                value={cpfColab}
                onChange={(e) => {
                  setCpfColab(maskCPF(e.target.value));
                }}
              />
              <TextField
                label="Nome"
                disabled
                variant="outlined"
                fullWidth
                value={nomeColab}
                onChange={(e) => {
                  setNomeColab(e.target.value);
                }}
              />
            </div>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Atendimento presencial
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <Autocomplete
                defaultValue={{
                  nome_comercial: getDataSchedule.nome_comercial,
                  value: getDataSchedule.nome_comercial
                }}
                fullWidth
                id="tags-outlined"
                options={listCredenciado}
                getOptionLabel={(option) => option.nome_comercial}
                onChange={(e, newValue, reasons) => {
                  handleData(newValue);
                }}
                value={selectedNomeComercial}
                onOpen={() => {
                  if (!isLoandingComercialName) {
                    reqStatus();
                  }
                }}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Nome Comercial"
                    placeholder="Nome Comercial"
                  />
                )}
              />
              <TextField
                disabled
                label="Nome comercial"
                variant="outlined"
                fullWidth
                value={nomeComercial}
                onChange={(e) => {
                  setNomeComercial(e.target.value);
                }}
              />
            </div>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <TextField
                label="Data do agendamento"
                variant="outlined"
                type="date"
                InputLabelProps={{
                  shrink: true
                }}
                onChange={(e) => {
                  setDataAgendamento(e.target.value);
                }}
                value={dataAgendamento}
              />
              <TextField
                label="Horário"
                type="time"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                value={horarioAgendamento}
                onChange={(e) => {
                  setHorarioAgendamento(e.target.value);
                }}
                disabled={ordemChegada === 'Sim'}
              />
              <FormControl>
                <Typography>Atendimento por ordem de chegada</Typography>
                <RadioGroup
                  defaultValue="Sim"
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                  value={ordemChegada}
                  onChange={(e) => {
                    setOrdemChegada(e.target.value);
                  }}
                >
                  <FormControlLabel
                    control={<Radio />}
                    value="Sim"
                    label="Sim"
                    style={{ marginRight: 50 }}
                  />
                  <FormControlLabel
                    control={<Radio />}
                    value="Não"
                    label="Não"
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <FormControl variant="outlined" style={{ width: '20%' }}>
                <InputLabel>Tipo de ASO</InputLabel>
                <Select
                  label="Tipo de ASO"
                  value={tipoAso}
                  onChange={(e: any) => {
                    setTipoAso(e.target.value);
                  }}
                >
                  {ASO.map((aso, index) => (
                    <MenuItem key={index} value={aso.value}>
                      {aso.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <TextField
                minRows={4}
                label="OBS"
                multiline
                variant="outlined"
                value={obs}
                onChange={(e) => {
                  setObs(e.target.value);
                }}
                fullWidth
              />
            </div>
          </Grid>
        </Grid>
      </Paper>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 20,
          marginTop: 20
        }}
      >
        {getDataSchedule?.token_kit && (
          <LinkKitButton
            token_kit={getDataSchedule.token_kit}
            id_agendamento={getDataSchedule.id_agendamento}
            data_agendamento={getDataSchedule.data_agendamento}
          />
        )}
        <Link to={'/agendamentos'} style={{ textDecoration: 'none' }}>
          <ButtonSair variant="outlined">Sair</ButtonSair>
        </Link>
        <ButtonAdd variant="outlined" onClick={sendAgendamento}>
          Salvar
        </ButtonAdd>
      </div>
      <Snackbar
        open={snack}
        autoHideDuration={2000}
        onClose={() => {
          setSnack(!snack);
        }}
      >
        <MuiAlert
          severity={severity}
          variant="filled"
        >{`${cod} - ${message}`}</MuiAlert>
      </Snackbar>
    </Container>
  );
};
